import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { ScenarioLearnableResponse } from 'src/types/domain';
import { useLanguagePairContext } from 'src/context/languagePair';
import { msgs } from './messages';
import * as S from './styles';

type LearnableCardProps = {
  learnable: ScenarioLearnableResponse;
} & S.LearnableProps;

const LearnableCard: FC<LearnableCardProps> = ({
  learnable: { targetValue, videoUrls },
  ...rest
}) => {
  const intl = useIntl();
  const { targetLanguageName } = useLanguagePairContext();

  const vocabulary = useMemo(() => {
    return { targetLanguageName };
  }, [targetLanguageName]);

  const label = intl.formatMessage(msgs.label, vocabulary);
  const meta = intl.formatMessage(msgs.meta, vocabulary);

  if (videoUrls.length === 0) return null;
  return (
    <S.LearnableCard {...rest}>
      <S.VideoPlayer
        CustomPlayButton={S.PlayButton}
        autoPlay={false}
        playOnKeyboardShortcut={false}
        preload="metadata"
        src={videoUrls[0]}
        title={targetValue}
      />

      <S.Data>
        <S.Label>{label}</S.Label>
        <S.Target title={targetValue}>{targetValue}</S.Target>
        <S.Meta>{`${targetLanguageName} · ${meta}`}</S.Meta>
      </S.Data>
    </S.LearnableCard>
  );
};

export default LearnableCard;
